import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Pagination from "../Reusablecomponents/Pagination";
import ExportButton from "../Reusablecomponents/ExportButton";
import "../css/others/Table.css";
import "../css/others/Popup.css";
import { apiCall } from "../main/ApiCall";
import { FaEdit, FaSort, FaSortDown, FaSortUp } from "react-icons/fa";
import EditFunctionCampaignPopup from "../popups/EditFunctionCampaignPopup";
import { createToastMessage, FunctionCampaigns, FunctionCampaignStatusEnum, ToastMessage } from '../interFaces/interfaces';
import EncryptionUtils from "../main/encryptionUtils";
import ToastPopup from "../popups/ToastPopup";
const FunctionCampaign: React.FC = () => {
  const [data, setData] = useState<FunctionCampaigns[]>([]);
  const [, setLoading] = useState<boolean>(true);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [itemsPerPage, setItemsPerPage] = useState<number>(10);
  const [totalPages, setTotalPages] = useState<number>(0);
  const [totalElements, setTotalElements] = useState<number>(0);
  const [selectedCampaign, setSelectedCampaign] = useState<FunctionCampaigns | null>(null);
  const [isPopupOpen, setIsPopupOpen] = useState<boolean>(false);
  const [fields, setFields] = useState<any>({});
  const [sortConfig, setSortConfig] = useState<{ key: string; direction: 'ascending' | 'descending' } | null>(null);
  const navigate = useNavigate();
  const [campaignStatusEnum, setCampaignStatusEnum] = useState<FunctionCampaignStatusEnum[]>([]);
  const clientId = localStorage.getItem("clientId");
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const columns = [{ key: "campaignName", label: "Function Campaign Name", sortable: true, headerRender: (label: string) => (<div className="sortable-header" onClick={() => requestSort("campaignName")}>{label}<span className="sort-icon">{getSortIcon("campaignName")}</span></div>) }, { key: "campaignType", label: "Function Campaign Type" }, { key: "auditObjective", label: "Function Audit Objective" }, { key: "auditScope", label: "Function Audit Scope" }, { key: "auditTeam", label: "Function Audit Team" }, { key: "location", label: "Function Location" }, { key: "createdBy", label: "Function Created By" }, { key: "updatedBy", label: "Function Updated By" }, { key: "updatedDate", label: "Function Updated Date" }, { key: "campaignStartDate", label: "Function Campaign Start Date" }, { key: "campaignEndDate", label: "Function Campaign End Date" }, { key: "createdDate", label: "Function Campaign Created Date" }, { key: "frequency", label: "Function Frequency" }, { key: "campignStatus", label: "Function Campaign Status" }];
  useEffect(() => {
    const permissions = EncryptionUtils.get<any>("permissions", null);
    if (permissions.tabs["functionCampaigns"]) {
      setFields(permissions.tabs["functionCampaigns"].fields);
    } else {
      console.log("No permissions found for 'functionCampaigns' tab");
    }
  }, []);
  const formatDate = (dateString: string | undefined | null): string => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };
  const getSortIcon = (key: string) => {
    if (!sortConfig || sortConfig.key !== key) {
      return <FaSort />;
    }
    return sortConfig.direction === 'ascending' ? <FaSortUp /> : <FaSortDown />;
  };
  const requestSort = (key: string) => {
    let direction: 'ascending' | 'descending' = 'ascending';
    if (sortConfig && sortConfig.key === key && sortConfig.direction === 'ascending') {
      direction = 'descending';
    }
    setSortConfig({ key, direction });
  };
  const sortedData = React.useMemo(() => {
    if (!sortConfig) return data;
    return [...data].sort((a, b) => {
      if (a[sortConfig.key] < b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? -1 : 1;
      }
      if (a[sortConfig.key] > b[sortConfig.key]) {
        return sortConfig.direction === 'ascending' ? 1 : -1;
      }
      return 0;
    });
  }, [data, sortConfig]);
  useEffect(() => {
    const fetchFunctionEnums = async () => {
      try {
        const response = await apiCall("get", "/api/enums/CampaignStatusEnum");
        setCampaignStatusEnum(response || []);
      } catch (error) {
        console.error("Error fetching function enums:", error);
      }
    };
    fetchFunctionEnums();
  }, []);
  const getFunctionDescription = (value: string) => {
    const enumItem = campaignStatusEnum.find(item => item.value === value);
    return enumItem ? enumItem.description : value || "N/A";
  };
  useEffect(() => {
    const fetchCampaigns = async () => {
      setLoading(true);
      try {
        const response = await apiCall("get", `/api/function/campaigns/all?page=${currentPage - 1}&size=${itemsPerPage}&clientId=${clientId}`);
        setData(response?.content || []);
        setTotalPages(response?.totalPages || 0);
        setTotalElements(response?.totalElements || 0);
      } catch (error) {
        console.error("Error fetching campaigns:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchCampaigns();
  }, [clientId, currentPage, itemsPerPage]);
  const fetchAllCampaigns = async (): Promise<FunctionCampaigns[]> => {
    try {
      const response = await apiCall("get", `/api/function/campaigns/all?page=0&size=${totalElements}&clientId=${clientId}`);
      const transformedData = (response.content || []).map((campaign: { campaignStatus: any; }) => ({ ...campaign, campignStatus: getFunctionDescription(campaign.campaignStatus || "N/A") }));
      return transformedData;
    } catch (error) {
      console.error("Failed to export campaigns. Please try again later.");
      return [];
    }
  };
  const handleCampaignIdClick = (campaignId: string, campaignName: string, campaignStatus: string) => {
    EncryptionUtils.set("functionCampaignName", campaignName);
    navigate(`/functioncampaigndetails/${campaignId}`, { state: { campaignName, campaignStatus } });
  };
  const handleEditClick = (campaign: FunctionCampaigns) => {
    setSelectedCampaign(campaign);
    setIsPopupOpen(true);
  };
  const handleCreateFunctionCampaign = async () => {
    try {
      const response = await apiCall("get", `/api/functions?status=ACTIVE&clientId=${clientId}&page=0&size=10`);
      const functionsData = response?.content || [];
      if (functionsData.length === 0) {
        setMessage(createToastMessage("Please create a function before creating a function campaign", "warning", 3000));
        return;
      }
      navigate("/createfunctionCampaign");
    } catch (error) {
      setMessage(createToastMessage("Something went wrong. Please try again.", "error", 3000));
    }
  };
  const handleClosePopup = () => { setIsPopupOpen(false); setSelectedCampaign(null) };
  return (
    <div className="table-details">
      <div className="table-title">
        <h2>Function Campaigns</h2>
        <div className="table-title-actions">
          {fields.create && (
            <button className="campaign-create" onClick={handleCreateFunctionCampaign}>Create Function Campaign</button>)}
          <ExportButton data={data.map(item => ({ ...item, campignStatus: getFunctionDescription(item.campaignStatus || "N/A") }))} columns={columns} fetchAllData={fetchAllCampaigns} fileName="function_campaigns" />
        </div>
      </div>
      <div>
        <div className="table-container">
          <div className="table-inner-container">
            <table className="main-table">
              <thead>
                <tr>
                  {columns.map((column) => (
                    <th key={column.key}>
                      {column.headerRender ? column.headerRender(column.label) : column.label}
                    </th>
                  ))}
                  {fields.edit && <th>Actions</th>}
                </tr>
              </thead>
              <tbody>
                {sortedData.length > 0 ? (
                  sortedData.map((campaign) => (
                    <tr key={campaign.campaignId}>
                      <td onClick={() => fields.view && handleCampaignIdClick(campaign.campaignId, campaign.campaignName, campaign.campaignStatus)} className={fields.view ? "clickable" : ""}>{campaign.campaignName}</td>
                      <td>{campaign.campaignType || "N/A"}</td>
                      <td>{campaign.auditObjective || "N/A"}</td>
                      <td>{campaign.auditScope || "N/A"}</td>
                      <td>{campaign.auditTeam || "N/A"}</td>
                      <td>{campaign.location || "N/A"}</td>
                      <td>{campaign.createdBy || "N/A"}</td>
                      <td>{campaign.updatedBy || "N/A"}</td>
                      <td>{formatDate(campaign.updatedDate) || "N/A"}</td>
                      <td>{formatDate(campaign.campaignStartDate) || "N/A"}</td>
                      <td>{formatDate(campaign.campaignEndDate) || "N/A"}</td>
                      <td>{formatDate(campaign.createdDate) || "N/A"}</td>
                      <td>{campaign.frequency || "N/A"}</td>
                      <td>{getFunctionDescription(campaign.campaignStatus || "N/A")}</td>
                      {fields.edit && (<td>{campaign.campaignStatus === "NOT_STARTED" ? (<FaEdit className="action-button" onClick={() => handleEditClick(campaign)} />) : ("N/A")}</td>)}
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={columns.length + (fields.edit ? 1 : 0)} className="no-data">No campaigns found.</td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
        <Pagination currentPage={currentPage} totalPages={totalPages} totalElements={totalElements} itemsPerPage={itemsPerPage} onPageChange={setCurrentPage} onItemsPerPageChange={setItemsPerPage} />
        {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}
      </div>
      {isPopupOpen && selectedCampaign && (
        <EditFunctionCampaignPopup campaign={selectedCampaign} onClose={handleClosePopup} />
      )}
    </div>
  );
};
export default FunctionCampaign;